/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase,
    rowSpacing,
    fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
    paletteHD,
} from './variables';

export const DesktopSubscriptionListStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        DesktopSubscriptionListStyle: {
            width: '100%',
            maxWidth: newPalette.myAccount.container.maxWidth.upLarge,
            margin: '0 auto',
            marginBottom: rowSpacing * 2,

            '& .subscriptionListWrapper': {
                border: `2px solid ${enterpriseCSS.palette.gray3}`,
            },

            '& .subscriptionHeader': {
                alignItems: 'flex-end',
                display: 'flex',
                fontSize: fontSizeDesktop.title,
                fontWeight: '700',
                padding: `${rowSpacing}px ${rowSpacing * 2}px`,
                backgroundColor: enterpriseCSS.palette.gray3,

                '& .subscriptionHeaderItem': {
                    display: 'inline-block',

                    '& .headerItemLabel': {
                        color: '#000',
                    },
                },
            },
            '& .subscriptionItemGrid': {
                padding: `${rowSpacing * 2}px`,

                '& .productInfoWrapper': {
                    marginBottom: rowSpacing,
                    '& img': {
                        float: 'left',
                        paddingRight: rowSpacing,
                        paddingBottom: rowSpacing,
                    },
                    '& .productInfo': {
                        float: 'left',
                        color: '#000',
                    },
                },

                '& .orderHistoryWrapper': {
                    paddingBottom: rowSpacing,

                    '& .historyTitle': {
                        fontWeight: 700,
                        color: '#000',
                        paddingBottom: rowSpacing / 2,
                    },
                    '& .orderHistoryTable': {
                        border: `1px solid ${enterpriseCSS.palette.gray3}`,
                        padding: rowSpacing,
                    },
                    '& .tableHead': {
                        color: '#000',
                        fontWeight: 700,
                        paddingBottom: rowSpacing / 2,
                    },
                    '& .tableBody': {
                        maxHeight: rowSpacing * 8,
                        minHeight: rowSpacing * 8,
                        overflow: 'hidden',
                        'overflow-y': 'auto',

                        '& .itemRow': {
                            padding: unitBase,
                            marginBottom: rowSpacing / 2,
                            '&:nth-child(2n + 1)': {
                                backgroundColor: enterpriseCSS.palette.gray3,
                            },
                        },
                    },
                },
            },

            '& .frequencyHead': {
                color: '#000',
                fontWeight: 700,
                paddingBottom: rowSpacing / 2,
            },
        },
    };
};
